import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center w-full align-center"
}
const _hoisted_2 = {
  key: 1,
  class: "p-3 d-flex justify-content-center"
}

import { useRouter } from 'vue-router'
import { FooterData, ButtomItemData } from '../../stores/footer'


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
    dataRender: { default: null }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

const tab = (item: ButtomItemData) => {
  if (item.action) {
    item.action()
  }
  if (item.router) {
    router.push(item.router)
  }
}

const isMiddleButton = (index: number): boolean => {
  // Middle button is at index 2 (0-indexed) in a 5-button layout
  const items = props.dataRender?.buttons?.items || []
  return index === Math.floor(items.length / 2)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_footer = _resolveComponent("v-footer")!

  return (__props.dataRender && __props.dataRender.show)
    ? (_openBlock(), _createBlock(_component_v_footer, {
        key: 0,
        color: __props.dataRender.color,
        style: _normalizeStyle({ '--footer-accent': __props.dataRender.color }),
        class: "text-white safari-footer",
        height: "56",
        app: ""
      }, {
        default: _withCtx(() => [
          (__props.dataRender.buttons.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataRender.buttons.items, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `button-${index}`
                  }, [
                    (item.round && item.label)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          rounded: "",
                          class: "m-1 footer-btn footer-btn-text",
                          onClick: ($event: any) => (tab(item)),
                          disabled: item.disabled
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "disabled"]))
                      : (item.icon)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            rounded: "",
                            icon: "",
                            class: "m-1 footer-btn footer-btn-icon",
                            onClick: ($event: any) => (tab(item)),
                            disabled: item.disabled
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.icon), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick", "disabled"]))
                        : _createCommentVNode("v-if", true),
                    (item.spacer)
                      ? (_openBlock(), _createBlock(_component_v_spacer, { key: 2 }))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          (__props.dataRender.default.show)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("span", null, "Vuetify", -1 /* CACHED */)),
                _createVNode(_component_v_spacer),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "© 2017", -1 /* CACHED */))
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["color", "style"]))
    : _createCommentVNode("v-if", true)
}
}

})